import { AnimatePresence, motion } from 'motion/react';
import PropTypes from 'prop-types';

export default function Heading({ keyProp = '', title, subtitle = '' }) {
	return (
		<AnimatePresence mode="wait">
			<hgroup className="trial__heading">
				<h1 className="h3">{title}</h1>
				{subtitle && (
					<motion.p
						key={keyProp}
						className="text-subline text-subline--sm"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1, transition: { delay: 0.375 / 2 } }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.5 }}
					>
						{subtitle}
					</motion.p>
				)}
			</hgroup>
		</AnimatePresence>
	);
}

Heading.propTypes = {
	keyProp: PropTypes.string,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
};
